// extracted by mini-css-extract-plugin
export default {"legend":"SignupLink_legend__efhoV","link":"SignupLink_link__KgP1U"};